import { render, staticRenderFns } from "./Layout_JianKang.vue?vue&type=template&id=fcf58170"
import script from "./Layout_JianKang.vue?vue&type=script&lang=js"
export * from "./Layout_JianKang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports